import { PartnerPayload } from '../interfaces/Partner';
import WashdayClientSingleton from './WashdayClientSingleton';

type PartnersSdk = {
  getPartners: () => Promise<any>;
  createPartner: (data: PartnerPayload) => Promise<any>;
  updatePartnerById: (id: string, data: Partial<PartnerPayload>) => Promise<any>;
  deletePartnerById: (id: string) => Promise<any>;
};

const getPartnersSdk = () =>
  WashdayClientSingleton.getInstance().partners as unknown as PartnersSdk;

export const getPartners = async () => {
  try {
    return await getPartnersSdk().getPartners();
  } catch (e) {
    console.log('[ERROR] getPartners', e);
    throw e;
  }
};

export const createPartner = async (data: PartnerPayload) => {
  try {
    return await getPartnersSdk().createPartner(data);
  } catch (e) {
    console.log('[ERROR] createPartner', e);
    throw e;
  }
};

export const updatePartnerById = async (id: string, data: Partial<PartnerPayload>) => {
  try {
    return await getPartnersSdk().updatePartnerById(id, data);
  } catch (e) {
    console.log('[ERROR] updatePartnerById', e);
    throw e;
  }
};

export const deletePartnerById = async (id: string) => {
  try {
    return await getPartnersSdk().deletePartnerById(id);
  } catch (e) {
    console.log('[ERROR] deletePartnerById', e);
    throw e;
  }
};
